enum CharacterTypes {
    Bob = "Bob",
    BillyBob = "Billy Bob",
    NinjaBob = "Ninja Bob",
    UncleBob = "Uncle Bob",
    Gerald = "Gerald"
}

export default CharacterTypes;